import * as React from "react";
import { PropsWithChildren } from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./style.module.css";

type TableProps = {
  className?: string;
};

export default function Table(props: PropsWithChildren<TableProps>) {
  const { children, className } = props;

  const sectionClass = createClasses([styles.tableWrapper, className]);

  return (
    <section className={sectionClass}>
      <table className={styles.tableComponent}>{children}</table>
    </section>
  );
}
